import { theme } from '../constants/defaults';
import htmlEscape from '../utils/htmlEscape';
import { normalizeProduct } from '../utils/product';
import searchResultsProductTemplate from './searchResultsProductTemplate';
import searchResultsOtherTemplate from './searchResultsOtherTemplate';
import loadingTemplate from './loadingTemplate';

function translateObject(item, translatedResults, type) {
  let loopArray = [];
  switch (type) {
    case 'article':
      loopArray = translatedResults.articles;
      break;
    case 'product':
      loopArray = translatedResults.products;
      break;
    case 'collection':
      loopArray = translatedResults.collections;
      break;
    case 'page':
      loopArray = translatedResults.pages;
      break;

    default:
      break;
  }

  // eslint-disable-next-line consistent-return
  loopArray.forEach(translateResult => {
    // console.log(item, translateResult);
    if (item.id === translateResult.id) {
      const translatedItem = item;
      translatedItem.title = translateResult.title;
      translatedItem.body = translateResult.body;
      return translatedItem;
    }
  });
}

function renderHeader(products, isLoading, headerString) {
  if (products.length === 0) {
    return '';
  }

  return `<div class="predictive-search-title">
      <h3 id="predictive-search" class="predictive-search-title__content">
        ${headerString}
      </h3>
      <span class="predictive-search-title__loading-spinner">
        ${isLoading ? '<span class= "icon-predictive-search-spinner" ></span>' : ''}
      </span>
    </div>`;
}

function loadingState() {
  return `<div class="predictive-search">
    ${loadingTemplate()}
  </div>`;
}

function renderViewAll(searchQuery) {
  return `<button type="submit" class="predictive-search-view-all__button" tabindex="-1">
    ${theme.strings.searchFor}
    <span class="predictive-search-view-all__query"> &ldquo;
      ${htmlEscape(searchQuery)}
      &rdquo;
    </span>
  </button>`;
}

function renderProducts(products, translatedResults) {
  const resultsCount = products.length;
  const productsList = products.map((product, index) => {
    let productObject = normalizeProduct(product);
    const translatedProduct = translateObject(productObject, translatedResults, 'product');
    if (translatedProduct) {
      productObject = translatedProduct;
    }
    return searchResultsProductTemplate(productObject, index, resultsCount);
  });

  return `${productsList.join('')}`;
}

function renderPages(products, translatedResults) {
  const resultsCount = products.length;

  const productsList = products.map((page, index) => {
    let pageObject = normalizeProduct(page);

    const translatedPage = translateObject(pageObject, translatedResults, 'page');
    if (translatedPage) {
      pageObject = translatedPage;
    }
    return searchResultsOtherTemplate(pageObject, index, resultsCount);
  });

  return `<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">
    ${productsList.join('')}
   
  </ul>`;
}
function renderArticles(articles, translatedResults) {
  const resultsCount = articles.length;

  const articlesList = articles.map((article, index) => {
    let articleObject = normalizeProduct(article);

    const translatedArticle = translateObject(articleObject, translatedResults, 'article');
    if (translatedArticle) {
      articleObject = translatedArticle;
    }

    return searchResultsOtherTemplate(articleObject, index, resultsCount);
  });

  return `<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">
    ${articlesList.join('')}
   
  </ul>`;
}

function renderCollections(collections, translatedResults) {
  const resultsCount = collections.length;
  const collectionsList = collections.map((collection, index) => {
    let collectionObject = normalizeProduct(collection);
    const translatedCollection = translateObject(collectionObject, translatedResults, 'collection');
    if (translatedCollection) {
      collectionObject = translatedCollection;
    }
    return searchResultsOtherTemplate(collectionObject, index, resultsCount);
  });

  return `<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">
    ${collectionsList.join('')}
   
  </ul>`;
}

function renderResults(
  products,
  collections,
  pages,
  articles,
  isLoading,
  searchQuery,
  translatedResults,
) {
  let productsResultsHTML = '';
  if (products && products.length) {
    productsResultsHTML = `
    ${renderHeader(products, isLoading, theme.strings.products)}
    ${renderProducts(products, translatedResults)}`;
  }
  let articlesResultsHTML = '';
  if (articles && articles.length) {
    articlesResultsHTML = `
    ${renderHeader(articles, isLoading, theme.strings.articles)}
    ${renderArticles(articles, translatedResults)}`;
  }
  let collectionsResultsHTML = '';
  if (collections && collections.length) {
    collectionsResultsHTML = `
    ${renderHeader(collections, isLoading, theme.strings.collections)}
    ${renderCollections(collections, translatedResults)}`;
  }
  let pagesResultsHTML = '';
  if (pages && pages.length) {
    pagesResultsHTML = `
    ${renderHeader(pages, isLoading, theme.strings.pages)}
    ${renderPages(pages, translatedResults)}`;
  }

  if (window.location.hash === '#pick-and-choose') {
    return `<div class="predictive-search">
  <ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">
   ${productsResultsHTML}
    ${collectionsResultsHTML}
  <li id="search-all" class="predictive-search-view-all" role="option" data-search-result>
  ${renderViewAll(searchQuery)}
</li>
  </ul>
   
  </div>`;
  }

  return `<div class="predictive-search">
  <ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">
   ${productsResultsHTML}
    ${articlesResultsHTML}
    ${collectionsResultsHTML}
    ${pagesResultsHTML}
  <li id="search-all" class="predictive-search-view-all" role="option" data-search-result>
  ${renderViewAll(searchQuery)}
</li>
  </ul>
   
  </div>`;
}

export const numberOfResultsTemplateFct = data => {
  if (data.products.length === 1) {
    return theme.strings.one_result_found;
  }

  return theme.strings.number_of_results_found.replace('[results_count]', data.products.length);
};

export const searchResultsTemplate = (data, translatedResults) => {
  const results = data || [];
  const products = data.products || [];
  const pages = data.pages || [];
  const collections = data.collections || [];
  const articles = data.articles || [];

  const { isLoading } = data;
  const searchQuery = data.searchQuery || '';
  let totalResultCount = 0;
  if (results.articles) {
    totalResultCount += results.articles.length;
  }
  if (results.collections) {
    totalResultCount += results.collections.length;
  }
  if (results.products) {
    totalResultCount += results.products.length;
  }
  if (results.pages) {
    totalResultCount += results.pages.length;
  }
  if (isLoading && totalResultCount === 0) {
    return loadingState();
  }

  return renderResults(
    products,
    collections,
    pages,
    articles,
    isLoading,
    searchQuery,
    translatedResults,
  );
};

// (a11y) This function will be used by the Predictive Search Component
// to announce that it's loading results
export const loadingResultsMessageTemplateFct = () => {
  return theme.strings.loading;
};
